export default __webpack_public_path__ + "static/web3-b86a4332cea83b825648949b594786d4.png";